import { auth, } from '@/firebase/config'
import { signOut } from "firebase/auth"
import store from "@/store"

/**
 * Signs the user out of the site.
 * 
 * @returns {Promise<void>}
 */
const logOut = async () => {
    await signOut(auth)
    store.commit('setUser', null)
    store.commit('setRememberMe', false)
}

const useSignout = () => {
    return { logOut, }
}

export default useSignout
